import { render, staticRenderFns } from "./RetinaScan.vue?vue&type=template&id=71af86d9&"
import script from "./RetinaScan.vue?vue&type=script&lang=js&"
export * from "./RetinaScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports